// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"142a5292","453":"ad616f94","455":"11720186"}[chunkId] + ".chunk.js";
};